import { NgModule } from '@angular/core';

import { SgKcSharedRoutingModule } from './sg-kc-shared-routing.module';
import { SharedModule } from 'cbc-shared-lib';
import { SgBaseSharedModule } from '../../sg-base/sg-base-shared/sg-base-shared.module';


@NgModule({
  declarations: [],
  imports: [
    SharedModule,
    SgKcSharedRoutingModule,
    SgBaseSharedModule,
  ],
  exports: [
  ],
  providers: [
  ]
})
export class SgKcSharedModule { }
